// PresenciaBenito — la "cara" del compañero MiPAE. No es una mascota nueva: es
// la firma de marca (punto + trazo manuscrito, ver SelloAnimado.jsx L114-126)
// reescalada a un glifo chico y viva según lo que Benito está haciendo. Usa
// currentColor para heredar el color del contenedor (accent en el panel,
// blanco sobre el FAB accent, blanco sobre el botón de la pestaña).
//
// Las animaciones viven en index.css (grupo "Presencia de Benito") y quedan
// cubiertas por el bloque prefers-reduced-motion: ahí basta con `animation:
// none`, porque cada estado ya define su valor final (opacity/scale/dashoffset)
// como regla estática fuera del keyframe — el mismo patrón que SelloAnimado.

const ARIA_POR_ESTADO = {
  reposo: "Benito",
  escuchando: "Benito está escuchando",
  pensando: "Benito está pensando",
  hablando: "Benito está hablando",
  // "contento": meneo corto del trazo al terminar una respuesta — la cola del
  // perro. Es identidad (Benito ES un perro), no un premio: dura ~2 s y vuelve
  // a reposo; bajo reduced-motion cae al glifo estático como todos los estados.
  contento: "Benito",
};

const ANCHO_VIEWBOX = 120;
const ALTO_VIEWBOX = 44;

export default function PresenciaBenito({ estado = "reposo", size = 28, className = "", ...resto }) {
  // No se propaga `resto` al DOM: así el componente ignora props ajenas (ej.
  // strokeWidth de un caller que lo trata como si fuera un ícono lucide) sin
  // levantar warnings de atributos desconocidos en el <span>.
  void resto;
  const estadoValido = ARIA_POR_ESTADO[estado] ? estado : "reposo";
  // El glifo es más ancho que alto (firma horizontal): deriva el alto desde
  // `size` (ancho) manteniendo la proporción del viewBox.
  const alto = Math.max(1, Math.round((size * ALTO_VIEWBOX) / ANCHO_VIEWBOX));

  return (
    <span
      role="img"
      aria-label={ARIA_POR_ESTADO[estadoValido]}
      className={`presencia-benito presencia-benito--${estadoValido} ${className}`.trim()}
    >
      <svg
        width={size}
        height={alto}
        viewBox={`0 0 ${ANCHO_VIEWBOX} ${ALTO_VIEWBOX}`}
        aria-hidden="true"
        focusable="false"
      >
        <circle className="presencia-benito__punto" cx="16" cy="30" r="6" fill="currentColor" />
        <path
          className="presencia-benito__trazo"
          d="M 26 30 Q 52 20, 74 27 T 112 25"
          stroke="currentColor"
          strokeWidth="3.2"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </span>
  );
}
